import React from 'react';
import { motion } from 'framer-motion';
import { useTheme } from '../context/ThemeContext';
import ContactSection from '../components/sections/ContactSection';

const ContactPage: React.FC = () => {
  const { themeConfig } = useTheme();

  const contactMethods = [
    {
      title: 'Email',
      value: 'sharmachaitanya945@gmail.com',
      href: 'mailto:sharmachaitanya945@gmail.com',
      icon: '📧',
      description: 'Best for detailed project discussions',
    },
    {
      title: 'Phone',
      value: '+91-8750539794',
      href: 'tel:+918750539794',
      icon: '📞',
      description: 'Available for urgent consultations',
    },
    {
      title: 'Upwork',
      value: 'Freelancer Profile',
      href: 'https://www.upwork.com/freelancers/~01f16adc9d2f50d399',
      icon: '💼',
      description: 'Hire me through Upwork platform',
    },
    {
      title: 'LinkedIn',
      value: 'Professional Network',
      href: 'https://linkedin.com/in/sharmachaitanya945',
      icon: '💡',
      description: 'Connect for professional networking',
    },
  ];

  const container = {
    hidden: { opacity: 0 },
    show: {
      opacity: 1,
      transition: {
        staggerChildren: 0.1,
      },
    },
  };

  const item = {
    hidden: { opacity: 0, y: 20 },
    show: { opacity: 1, y: 0 },
  };

  return (
    <div className="min-h-screen">
      {/* Header */}
      <section className={`${themeConfig.layout?.sectionStyle} text-center`}>
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8 }}
        >
          <h1 className="text-4xl lg:text-5xl font-bold mb-6 text-[var(--color-primary)]">
            Let's Work Together
          </h1>
          <p className="text-xl mb-8 text-[var(--color-text)] opacity-90 max-w-3xl mx-auto">
            I'm available for freelance AI/ML projects, consultations, and long-term collaborations. 
            Let's discuss how I can help bring your ideas to life.
          </p>
        </motion.div>
      </section>

      {/* Contact Methods */}
      <section className={`${themeConfig.layout?.sectionStyle}`}>
        <h2 className="text-3xl font-bold mb-10 text-[var(--color-primary)] text-center">Get In Touch</h2>
        
        <motion.div
          className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-12"
          variants={container}
          initial="hidden"
          whileInView="show"
          viewport={{ once: true }}
        >
          {contactMethods.map((method, idx) => (
            <motion.a
              key={idx}
              href={method.href}
              target={method.href.startsWith('http') ? '_blank' : undefined}
              rel={method.href.startsWith('http') ? 'noopener noreferrer' : undefined}
              className="p-6 rounded-lg border border-[var(--color-secondary)] hover:shadow-lg transition-all block"
              variants={item}
            >
              <div className="flex items-center gap-4">
                <div className="text-3xl">{method.icon}</div>
                <div>
                  <h3 className="text-lg font-semibold text-[var(--color-primary)]">{method.title}</h3>
                  <p className="text-[var(--color-text)] opacity-80 mb-1">{method.value}</p>
                  <p className="text-sm text-[var(--color-text)] opacity-60">{method.description}</p>
                </div>
              </div>
            </motion.a>
          ))}
        </motion.div>
      </section>

      {/* Contact Form */}
      <ContactSection />

      {/* Response Time Info */}
      <section className={`${themeConfig.layout?.sectionStyle} text-center`}>
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          className="max-w-2xl mx-auto p-6 rounded-lg border border-[var(--color-secondary)]"
        >
          <h3 className="text-xl font-semibold mb-4 text-[var(--color-primary)]">Response Time</h3>
          <p className="text-[var(--color-text)] opacity-80 mb-4">
            I typically respond to inquiries within 24 hours during weekdays. 
            For urgent projects, feel free to call or message me directly.
          </p>
          <div className="flex justify-center gap-4 text-sm">
            <div>
              <span className="font-semibold">Email:</span> 24-48 hours
            </div>
            <div>
              <span className="font-semibold">Upwork:</span> 12-24 hours
            </div>
            <div>
              <span className="font-semibold">Phone:</span> Same day
            </div>
          </div>
        </motion.div>
      </section>
    </div>
  );
};

export default ContactPage;
